"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _xDatePickers = require("@mui/x-date-pickers");
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _IconButton = _interopRequireDefault(require("../Components/IconButton"));
var _Clear = _interopRequireDefault(require("@mui/icons-material/Clear"));
var _DatePickerModule = _interopRequireDefault(require("./DatePicker.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Highlights/only allows selecting operating days (if supplied).
 *
 * @param {Object} props
 * @return {ReactNode}
 */const DatePicker = props => {
  const {
    name,
    onChange,
    selectableDays,
    value
  } = props;
  const todayYmd = (0, _react.useMemo)(() => new _moment.default().format("YYYY-MM-DD"), []);

  /**
   * Get whether a particular date should be disabled.
   *
   * We only allow selection of dates where they are in the selectable list.
   *
   * @param {Moment} date
   * @return {Boolean}
   */
  const shouldDisableDate = (0, _react.useCallback)(date => {
    const dateYmd = date.format("YYYY-MM-DD");
    if (!selectableDays) return false;else if (dateYmd === value || dateYmd === todayYmd) return false;else if (!selectableDays?.length) return true;else return !selectableDays.includes(dateYmd);
  }, [selectableDays, todayYmd, value]);

  /**
   * Date changed.
   *
   * @param {String|Null} date
   * @return {void}
   */
  const handleChange = (0, _react.useCallback)(date => {
    // const dateValue = new moment((date || (props.focusFirstSelectableDay ? selectableDays?.[0] : undefined) || (!props.clearable ? todayYmd : null)));

    if (!date || !shouldDisableDate(date)) {
      onChange(date, name);
    }
  }, [name, onChange, shouldDisableDate]);

  /**
   * Date cleared.
   *
   * @return {void}
   */
  const handleClear = (0, _react.useCallback)(() => {
    handleChange(null);
  }, [handleChange]);

  /**
   * Maximum selection date
   */
  const maxDate = selectableDays ? selectableDays?.[selectableDays.length - 1] || todayYmd : props.maxDate;

  /**
   * CSS class string
   */
  const className = [props.className, selectableDays ? _DatePickerModule.default.mui : undefined, selectableDays && !selectableDays?.includes(todayYmd) ? _DatePickerModule.default.notAvailable : undefined].filter(cls => cls).join(" ");

  /**
   * Formats a MUIX calendar day, using a list of supplied foreground/background properties.
   */
  const formatDayStyle = props => {
    const {
      dayStyles = [],
      day,
      outsideCurrentMonth,
      ...other
    } = props;
    const thisDayStyle = dayStyles.find(x => x.date === props.day.format("YYYY-MM-DD"));
    const shouldHighlight = !!(!props.outsideCurrentMonth && thisDayStyle);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_xDatePickers.PickersDay, {
      ...other,
      className: shouldHighlight ? _DatePickerModule.default.styleManaged : undefined,
      outsideCurrentMonth: outsideCurrentMonth,
      day: day,
      style: shouldHighlight ? {
        ...thisDayStyle
      } : undefined
    });
  };

  // Determine which component to render

  let DatePickerComponent;
  let DatePickerProps;
  switch (props.variant) {
    case "calendar":
      DatePickerComponent = _xDatePickers.DateCalendar;
      break;
    case "desktop":
      DatePickerComponent = _xDatePickers.DesktopDatePicker;
      break;
    case "mobile":
      DatePickerComponent = _xDatePickers.MobileDatePicker;
      break;
    case "responsive":
      DatePickerComponent = _xDatePickers.DatePicker;
      break;
    case "static":
      DatePickerComponent = _xDatePickers.StaticDatePicker;
      DatePickerProps = {
        displayStaticWrapperAs: props.displayStaticWrapperAs
      };
      break;
    default:
      DatePickerComponent = _xDatePickers.DatePicker;
      break;
  }

  /**
   * Render!
   */
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `${props.clearable ? _DatePickerModule.default.container__clearable : ""} ${className}`.trim(),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DatePickerComponent, {
      ...DatePickerProps,
      // autoOk={true}

      className: className,
      color: props.color,
      disabled: props.disabled,
      disableFuture: props.disableFuture,
      disablePast: props.disablePast

      // emptyLabel="(Any)"

      // initialFocusedDate={(props.focusFirstSelectableDay ? selectableDays?.[0] : undefined)}
      ,

      format: props.format,
      maxDate: new _moment.default(maxDate),
      name: name,
      onChange: handleChange,
      openTo: props.openTo,
      orientation: props.orientation,
      slots: {
        day: formatDayStyle
      },
      slotProps: {
        ...props.slotProps,
        day: {
          dayStyles: props.dayStyles,
          sx: {
            fontSize: 14
          }
        },
        openPickerIcon: {
          /** This bullshit is needed to fix the tiny icon due to the 62.5% font size */
          sx: {
            fontSize: 36,
            height: 24
          }
        }
      },
      shouldDisableDate: shouldDisableDate,
      value: value,
      views: props.views,
      yearsOrder: props.yearsOrder

      // PopoverProps={{className, disableScrollLock: true}}
    }), props.clearable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      color: props.color,
      disabled: !value && props.clearable || props.disabled,
      icon: _Clear.default,
      onClick: handleClear,
      size: "small",
      tooltip: "Clear"
    })]
  });
};
DatePicker.propTypes = {
  className: _propTypes.default.string,
  clearable: _propTypes.default.bool,
  color: _propTypes.default.oneOf(["primary", "secondary"]),
  dayStyles: _propTypes.default.arrayOf(_propTypes.default.object),
  disabled: _propTypes.default.bool,
  disableFuture: _propTypes.default.bool,
  disablePast: _propTypes.default.bool,
  displayStaticWrapperAs: _propTypes.default.oneOf(["desktop", "mobile"]),
  focusFirstSelectableDay: _propTypes.default.bool,
  format: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  openTo: _propTypes.default.oneOf(["day", "month", "year"]),
  orientation: _propTypes.default.string,
  selectableDays: _propTypes.default.arrayOf(_propTypes.default.string),
  value: _propTypes.default.object,
  variant: _propTypes.default.oneOf(["calendar", "desktop", "inline", "mobile", "responsive", "static"]),
  views: _propTypes.default.array,
  yearsOrder: _propTypes.default.oneOf(["asc", "desc"])
};
DatePicker.defaultProps = {
  clearable: false,
  color: "primary",
  disabled: false,
  focusFirstSelectableDay: false,
  format: "YYYY-MM-DD",
  maxDate: null,
  variant: "static"
};
var _default = exports.default = DatePicker;